import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import DashboardHeader from "./dashboard/DashboardHeader";
import DashboardFooter from "./dashboard/DashboardFooter";
import { Hero } from "./Hero";

export default function Dashboard() {
  const location = useLocation();
  const isHomePage = location.pathname === "/" || location.pathname === "/dashboard";

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        background: "#f9fafb",
      }}
    >
      <DashboardHeader />
      {isHomePage && <Hero />}
      <main
        style={{
          flex: 1,
          padding: "24px",
          maxWidth: "1400px",
          margin: "0 auto",
          width: "100%",
        }}
      >
        <Outlet />
      </main>
      {false && <DashboardFooter />}
    </div>
  );
}
